import i18n from "@/plugins/i18n";

export default {
  handle(res, dispatch, credentials, message = null) {
    if (res.response.status === 401) {
      dispatch(
        "users/login",
        {
          email: credentials.email,
          password: credentials.password
        },
        { root: true }
      );
    }

    dispatch(
      "alert/error",
      message == null ? i18n.t("common.error") : message,
      { root: true }
    );
  }
};
